// @ts-nocheck
import { type FC } from 'react'
import rebrandingStarSrc from 'views/assets/images/icons/rebranding_star.svg?color=yellowStar'
import rebrandingStarTransparentSrc from 'views/assets/images/icons/rebranding_star.svg?fill=yellowStar&fill-rule=evenodd'
import starSrc from 'views/assets/images/icons/star.svg?color=star'
import starBackgroundSrc from 'views/assets/images/icons/star.svg?color=star&fill=background'
import starTransparentSrc from 'views/assets/images/icons/star.svg?color=star&fill=none'

import { isRebrandingCOMActive } from 'shared/experiments/utils/rebranding'
import IconImage from 'views/components/atoms/IconImage'
import { ICON_SIZE } from 'views/consts'
import { usePageProperties } from 'views/utils/shopAndRuntimeConfigUtils'

export interface StarIconProps {
  size?: typeof ICON_SIZE[number]
  className?: string
  transparent?: boolean
  filled?: boolean
}

const StarIcon: FC<StarIconProps> = ({
  size = 'default',
  className = undefined,
  transparent = false,
  filled = false,
} = {}) => {
  const { experiments } = usePageProperties()
  const isRebrandingCOMEnabled = isRebrandingCOMActive(experiments)

  let src = starSrc
  if (!filled) {
    src = transparent ? starTransparentSrc : starBackgroundSrc
  }

  if (isRebrandingCOMEnabled) {
    src = rebrandingStarSrc

    if (!filled) {
      src = rebrandingStarTransparentSrc
    }
  }

  return <IconImage alt="" src={src} className={className} size={size} />
}

export default StarIcon
